import "./App.scss";

function App() {
  return (
    <div className="app">
      <div className="app__maintenance">
        <h1>🚧 Site Under Maintenance 🚧</h1>
        <p>We're working on some improvements. Please check back soon!</p>
      </div>
    </div>
  );
}

export default App;
